import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const e = i((o, s) => /* @__PURE__ */ a.jsx(
  r,
  {
    ref: s,
    ...o,
    image: (t) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "#1D1D44",
            d: "M5.481 9.247c-.11.6-.544 3.397-.672 4.187-.009.057-.03.078-.093.078H2.384a.38.38 0 0 1-.378-.434L3.837 1.456a.635.635 0 0 1 .625-.528c4.76 0 5.16-.116 6.376.356 1.878.728 2.05 2.485 1.375 4.385-.672 1.956-2.266 2.797-4.379 2.822-1.356.021-2.172-.22-2.353.756M13.16 4.75c-.056-.04-.078-.056-.093.04-.063.357-.16.704-.275 1.05C11.544 9.398 8.087 9.088 6.4 9.088c-.19 0-.316.104-.34.294-.707 4.388-.848 5.303-.848 5.303-.03.222.11.403.332.403h1.984a.56.56 0 0 0 .544-.465c.022-.169-.035.19.45-2.853.144-.688.447-.616.915-.616 2.22 0 3.95-.9 4.466-3.51.203-1.087.144-2.23-.744-2.893"
          }
        )
      }
    )
  }
));
e.displayName = "PayPalIcon";
export {
  e as PayPalIcon,
  e as default
};
//# sourceMappingURL=index.js.map
